import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  align-items: center;
`;

const Label = styled.label`
  margin-top: 0.2rem;
  margin-left: 1rem;

  font-size: 1.2rem;
`;

export { Wrapper, Label };
